import gql from 'graphql-tag';

export const facilityTypes = gql`
  query getAllFacilityTypes {
    getAllFacilityTypes {
      code
      status
      data {
        id
        facilityTypeCode
        name
        deleted
      }
    }
  }
`;
export const saveFacility = gql`
  mutation saveFacility($facilityDto: FacilityDtoInput) {
    saveFacility(facilityDto: $facilityDto) {
      code
      status
      data {
        id
        name
        facilityCode
        facilityType {
          id
          name
        }
        residence {
          id
          name
        }
      }
    }
  }
`;
